import React from "react";
import { FREQUENCIA, TIPO_EXCEL } from "./enums";

export default function ReportRow({
  item,
  config,
  onToggle,
  onFrequenciaChange,
  onTipoExcelChange,
}) {
  const isActive = !!config?.ativo;
  const isExcel = item.tipo === "EXCEL";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: "10px 0",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
        <div className="form-check form-switch" style={{ minWidth: 44 }}>
          <input
            className="form-check-input"
            type="checkbox"
            checked={isActive}
            id={`report-toggle-${item.id}`}
            onChange={(event) => onToggle(item.id, event.target.checked, item.tipo)}
          />
        </div>

        <div
          style={{
            minWidth: 420,
            fontWeight: 500,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={item.nome}
        >
          {item.nome}
        </div>
      </div>

      {isActive && (
        <div style={{ display: "flex", alignItems: "center", gap: 24, flexWrap: "wrap", marginTop: 12, marginLeft: 56 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span>Frequência:</span>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name={`frequencia-radio-${item.id}`}
                  id={`frequencia-diario-${item.id}`}
                  checked={(config.frequencia || FREQUENCIA.DIARIO) === FREQUENCIA.DIARIO}
                  onChange={() => onFrequenciaChange(item.id, FREQUENCIA.DIARIO)}
                />
                <label htmlFor={`frequencia-diario-${item.id}`} className="form-check-label">
                  Diário
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name={`frequencia-radio-${item.id}`}
                  id={`frequencia-semanal-${item.id}`}
                  checked={config.frequencia === FREQUENCIA.SEMANAL}
                  onChange={() => onFrequenciaChange(item.id, FREQUENCIA.SEMANAL)}
                />
                <label htmlFor={`frequencia-semanal-${item.id}`} className="form-check-label">
                  Semanal
                </label>
              </div>
            </div>
          </div>

          {isExcel && (
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span>Excel:</span>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name={`excel-radio-${item.id}`}
                    id={`excel-aba-unica-${item.id}`}
                    checked={(config.tipoExcel || TIPO_EXCEL.ABA_UNICA) === TIPO_EXCEL.ABA_UNICA}
                    onChange={() => onTipoExcelChange(item.id, TIPO_EXCEL.ABA_UNICA)}
                  />
                  <label htmlFor={`excel-aba-unica-${item.id}`} className="form-check-label">
                    Aba única
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name={`excel-radio-${item.id}`}
                    id={`excel-abas-separadas-${item.id}`}
                    checked={config.tipoExcel === TIPO_EXCEL.ABAS_SEPARADAS}
                    onChange={() => onTipoExcelChange(item.id, TIPO_EXCEL.ABAS_SEPARADAS)}
                  />
                  <label htmlFor={`excel-abas-separadas-${item.id}`} className="form-check-label">
                    Abas separadas
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
